import { IEnvironment } from 'src/app/environment.interface';
import { baseEnviroment } from 'src/environments/environment.base';

export const environment: IEnvironment = {
  ...baseEnviroment,
  production: true,
  environment: 'prod',
  host: 'https://www.smcuivre.com',
  apiUri: 'https://rest.api.smcuivre.com/',
  auth0: {
    domain: 'smc-prod.eu.auth0.com',
    clientId: '8pdHG3hlyeFo1FWFevCrllaLX7ntrWvL',
    useRefreshTokens: true,
    cacheLocation: 'memory',
    //useRefreshTokensFallback: true,
    authorizationParams: {
      redirect_uri: `${window.location.origin}`,
      audience: 'https://rest.api.smcuivre.com',
      scope: 'offline_access profile email',
    },
    httpInterceptor: {
      allowedList: [
        {
          uri: 'https://rest.api.smcuivre.com*',
          allowAnonymous: true,
        },
      ],
    },
  },
  awsRum: {
    config: {
      sessionSampleRate: 1,
      guestRoleArn:
        'arn:aws:iam::839215185105:role/prod-rum-identity-pool-unauthenticated-role',
      identityPoolId: 'eu-west-1:20ab9738-b6b4-46a9-a46c-8d77c31bfc9f',
      endpoint: 'https://dataplane.rum.eu-west-1.amazonaws.com',
      telemetries: ['errors', 'http', 'performance'],
      allowCookies: true,
      enableXRay: false,
    },
    APPLICATION_ID: 'c9d6ec3c-1c8f-44b7-ac77-e9219d4c82ec',
    APPLICATION_VERSION: '1.0.0',
    APPLICATION_REGION: 'eu-west-1',
  },
  ga: {
    trackingCode: 'G-HBSX4PT1YC',
    routing: {
      exclude: ['/miscellaneous/home'],
      include: ['*/account/*', '*/product/*'],
    },
  },
};
